export default __webpack_public_path__ + "static/media/TF4-2.90d2f18c.jpg";